import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {SubmitButtonComponent} from "../submit-button/submit-button.component";
import {DataUpdateService} from "../../services/data-update.service";

/** Shown in place of a loading state when the app's data refresh failed; "Try again" refreshes it. */
@Component({
  selector: 'homey-load-failed',
  imports: [
    SubmitButtonComponent
  ],
  templateUrl: './load-failed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col items-center text-center gap-3 py-8'
  }
})
export class LoadFailedComponent {
  private readonly dataUpdateService = inject(DataUpdateService);

  protected readonly retry = () => this.dataUpdateService.retry();
}
